import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksLineItemsSection', {
    colNameServiceDate: 'Service Date',
    colNameItem: 'Product/Service',
    colNameDescription: 'Description',
    colNameQty: 'Qty',
    colNameUnitPrice: 'Rate',
    colNameAmount: 'Amount',
    colNameAmountWithCurrency: 'Amount ({currency})',
    colNameLinked: 'Linked',
    colNameTaxCode: 'Tax',
    colNameCustomer: 'Customer',
    colNameClass: 'Class',
    colNameBillable: 'Billable',
    colNameTax: 'Tax',
    cellPlaceholderServiceDate: 'Enter Service Date',
    cellPlaceholderItem: 'Select Product/Service',
    cellPlaceholderDescription: 'Enter a description',
    cellPlaceholderQty: 'Enter qty',
    cellPlaceholderUnitPrice: 'Enter rate',
    cellPlaceholderTaxCode: 'Select Tax Code',
    cellPlaceholderCustomer: 'Select a Customer',
    cellPlaceholderClass: 'Select a Class',
    headerText: 'Line items',
    lineAmountTypeLabel: 'Amounts are',
    groupEdit: 'Edit selected',
    groupClone: 'Clone selected',
    groupRemove: 'Remove selected',
});
